// Wishlist: ultra-robust size/variant text capture + safe fetch fallback
(function () {
  const KEY = 'wp_wishlist_v1';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // ---- storage helpers ----
  function load(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(_) { return []; } }
  function save(list){ localStorage.setItem(KEY, JSON.stringify(list)); }
  function upsert(item){
    const list = load();
    const i = list.findIndex(x => String(x.id) === String(item.id));
    if (i >= 0) list[i] = item; else list.push(item);
    save(list);
  }

  // ---- try MANY patterns to read the selected option text from the product form ----
  function text(el){ return (el && el.textContent ? el.textContent : '').trim(); }
  function fromNodeList(nl){ return Array.from(nl || []).map(text).filter(Boolean).join(' / '); }

  function getVariantTextFromForm(form){
    if (!form) return '';

    // A) Common “pill” / button patterns
    const activePills = form.querySelectorAll(
      // aria-selected / pressed / checked
      '[aria-selected="true"],[aria-pressed="true"],[aria-checked="true"],' +
      // data-selected flags
      '[data-selected="true"],[data-checked="true"],' +
      // very common “active/selected” classes
      '.is-selected,.is-active,.active,.selected,' +
      // theme variants
      '.button--active,.swatch__item--selected,.variant-option.is-selected,' +
      '.product-variant__option--selected,.product-option--selected'
    );
    const pillsTxt = fromNodeList(activePills);
    if (pillsTxt) return pillsTxt;

    // B) Radio inputs + their labels
    const radioChecked = form.querySelectorAll(
      'input[type="radio"][name^="options["]:checked, input[type="radio"][name^="option"]:checked'
    );
    if (radioChecked && radioChecked.length){
      const viaRadios = Array.from(radioChecked).map(r => {
        const lbl = r.nextElementSibling && r.nextElementSibling.tagName === 'LABEL'
          ? r.nextElementSibling
          : form.querySelector(`label[for="${r.id}"]`);
        return (lbl ? lbl.textContent : r.value).trim();
      }).filter(Boolean).join(' / ');
      if (viaRadios) return viaRadios;
    }

    // C) Checked input followed by label (Dawn style)
    const checkedLabels = form.querySelectorAll('.product-form__input input:checked + label, label.variant__button-label--active');
    const labelsTxt = fromNodeList(checkedLabels);
    if (labelsTxt) return labelsTxt;

    // D) Variant dropdown
    const select = form.querySelector('select[name="id"]');
    if (select && select.selectedOptions && select.selectedOptions[0]){
      const optTxt = select.selectedOptions[0].textContent.trim();
      if (optTxt && !/^\d+$/.test(optTxt)) return optTxt;
    }

    // E) Try the group labeled “Size”
    const sizeGroup = Array.from(form.querySelectorAll('fieldset, .product-form__input, .product-form__input--pill, .product-form__input--dropdown'))
      .find(el => /size/i.test(el.textContent || ''));
    if (sizeGroup){
      const activeInGroup = sizeGroup.querySelectorAll('[aria-selected="true"],[aria-pressed="true"],[aria-checked="true"],.is-selected,.is-active,.active,.selected,input:checked+label');
      const groupTxt = fromNodeList(activeInGroup);
      if (groupTxt) return groupTxt;
    }

    return '';
  }

  // Fallback: ask Shopify for the variant title (e.g., “Small”, or “Small / Black”)
  async function getVariantTitleViaJSON(variantId){
    try{
      const r = await fetch(`${ROOT}variants/${variantId}.json`);
      if (!r.ok) return '';
      const v = await r.json();
      return v && v.title ? v.title : '';
    }catch(_){ return ''; }
  }

  // ---- wire the Add to Wishlist button ----
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('.wp-wishlist-btn');
    if (!btn) return;

    const form = btn.closest('form') || document.querySelector('form[action="/cart/add"]');
    const idInput = form && form.querySelector('input[name="id"]');
    const qtyInput = form && form.querySelector('input[name="quantity"]');

    const variantId = idInput && idInput.value;
    if (!variantId){ alert('Please choose a size/variant first.'); return; }

    const qty = qtyInput ? Number(qtyInput.value || 1) : 1;
    const productTitle = btn.getAttribute('data-product-title') || 'Saved item';
    const base = btn.getAttribute('data-product-url') || window.location.pathname;
    const url = base + (base.includes('?') ? '&' : '?') + 'variant=' + variantId;

    // Get size/variant text; if still empty, use Shopify’s variant title as a fallback
    let variantText = getVariantTextFromForm(form);
    if (!variantText) variantText = await getVariantTitleViaJSON(variantId);

    upsert({ id: String(variantId), qty, title: productTitle, url, variant: variantText });

    const original = btn.textContent;
    btn.textContent = 'Added!';
    setTimeout(() => (btn.textContent = original), 1200);
  });
})();